var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormGroup, FormControl } from "@angular/forms";
import { DateValidators } from "../../shared/validators/date.validators";
var CapacityReportFormGroup = /** @class */ (function (_super) {
    __extends(CapacityReportFormGroup, _super);
    function CapacityReportFormGroup() {
        return _super.call(this, {
            plantingDateRange: new FormControl(null, DateValidators.DateRangeValidator())
        }) || this;
    }
    Object.defineProperty(CapacityReportFormGroup.prototype, "plantingDateRangeFormControl", {
        get: function () {
            return this.get("plantingDateRange");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CapacityReportFormGroup.prototype, "plantingDateRange", {
        get: function () {
            return this.plantingDateRangeFormControl && this.plantingDateRangeFormControl.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CapacityReportFormGroup.prototype, "plantingStartDate", {
        get: function () {
            return this.plantingDateRange && this.plantingDateRange.length > 1 && this.plantingDateRange[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CapacityReportFormGroup.prototype, "plantingEndDate", {
        get: function () {
            return this.plantingDateRange && this.plantingDateRange.length > 1 && this.plantingDateRange[1];
        },
        enumerable: true,
        configurable: true
    });
    return CapacityReportFormGroup;
}(FormGroup));
export { CapacityReportFormGroup };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/capacity-report-form/capacity-report-form.formgroup.ts.pre-build-optimizer.js